/** Search carried through the /screen routes: the /signup search the patient continues to if eligible. */
export interface ScreenerSearchT {
    signup?: Record<string, unknown>;
}

function asRecord(value: unknown): Record<string, unknown> | null {
    return value && typeof value === "object" && !Array.isArray(value) ? (value as Record<string, unknown>) : null;
}

export function parseScreenerSearch(search: Record<string, unknown>): ScreenerSearchT {
    const signup = asRecord(search.signup);
    return signup ? { signup } : {};
}

/**
 * The /signup search for an eligible patient, with a fresh quickstart_id so each sign-up through the
 * same link gets its own quickstart. Null when the screener was opened without a sign-up link.
 */
export function screenerSignupSearch(signup: unknown, quickstartId: string): Record<string, unknown> | null {
    const search = asRecord(signup);
    if (!search) return null;
    return { role: "PATIENT", ...search, quickstart_id: quickstartId };
}

/** The organisation that sent the sign-up link, so responses can be read by that organisation. */
export function screenerSignupOrganisationId(signup: unknown): string | null {
    const search = asRecord(signup);
    const organisationId = search?.organisation_id ?? asRecord(search?.organisation)?.organisation_id;
    return typeof organisationId === "string" && organisationId.trim() !== "" ? organisationId.trim() : null;
}

/**
 * Where a patient sign-up link should go: straight to /signup, or through the template's screener first.
 * Pass the result to router.buildLocation.
 */
export function signupOrScreenerLocation(signupSearch: Record<string, unknown>, screenerId: unknown) {
    if (typeof screenerId === "string" && screenerId.trim() !== "") {
        return {
            to: "/screen/$screenerId" as const,
            params: { screenerId: screenerId.trim() },
            search: { signup: signupSearch },
        };
    }
    return { to: "/signup" as const, search: signupSearch };
}
